export default "__VITE_ASSET__BxCqLI2A__"